module.exports = __webpack_public_path__ + "img/top1@2x.0b672d52.png";